import { logout } from '../../api/user'
import yunLocalStorage from '@yld/yun-utils-local-storage'

const state = {
  userInfo: {},
  loginResponse: {},
  aliasName: ''
}

const mutations = {
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_LOGIN_RESPONSE: (state, loginResponse) => {
    state.loginResponse = loginResponse
    if (loginResponse.aliasName) {
      state.aliasName = loginResponse.aliasName
      localStorage.setItem('aliasName', loginResponse.aliasName)
    }
  },
  SET_ALIAS_NAME: (state, aliasName) => {
    state.aliasName = aliasName
  }
}

const actions = {
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      const userInfo = yunLocalStorage.getStorage('prime_user_info')
      if (userInfo) {
        commit('SET_USER_INFO', userInfo)
        if (userInfo.aliasName) {
          commit('SET_ALIAS_NAME', userInfo.aliasName)
          localStorage.setItem('aliasName', userInfo.aliasName)
        }
      } else {
        commit('SET_USER_INFO', {})
      }
      resolve(userInfo)
    })
  },
  setLoginResponse({ commit }, loginResponse) {
    commit('SET_LOGIN_RESPONSE', loginResponse)
  },
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
